import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 70px;
`;
export const ContainerHeader = styled.div`
  margin-top: 48px;
  text-align-last: center;
`;
export const Title = styled.div`
  font-weight: 700;
  font-size: 30px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.024em;
  color: #000000;
  margin-top: 16px;
`;

export const ContainerData = styled.div`
  display: grid;
  justify-content: center;
  margin-top: 40px;
  gap: 24px;
`;
